// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import {
  filterAndSortPathIds,
  updateProjectSort,
} from 'redux/modules/projectSummary'

// update the sort values in redux state
// then update the visiblePathIds list with this new sorting.

const assignProjectSort = newCol => (dispatch, getState) => {
  const { projectSummary } = getState()
  const oldAsc = projectSummary.get('sortAsc')
  const oldCol = projectSummary.get('sortCol')

  // if we're sorting by a new column, make it ascending,
  // otherwise toggle asc
  const projectSort = {
    sortAsc: oldCol !== newCol ? true : !oldAsc,
    sortCol: newCol,
  }

  dispatch(updateProjectSort(projectSort))
  dispatch(filterAndSortPathIds())
}

export default assignProjectSort
